import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { FileOutput } from 'dtos/diligence/FileOutput';
import { observer } from 'mobx-react-lite';

type DeleteConfirmModalProps = {
  visible: boolean;
  disabled: boolean;
  file?: FileOutput;
  onClose: () => void;
  onConfirm: () => void;
};

const DeleteConfirmModal = observer(({ visible, disabled, file, onClose, onConfirm }: DeleteConfirmModalProps) => {
  return (
    <Dialog open={visible} maxWidth="sm" onClose={disabled ? undefined : onClose}>
      <DialogTitle>Are you sure you want to delete the file {file?.name}?</DialogTitle>
      <DialogContent>
        Deleting a file will permanently remove it from your Uploaded Files List and your appraiser won't be able to
        access it.
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" autoFocus onClick={onClose} disabled={disabled}>
          Cancel
        </Button>
        <Button variant="contained" color="error" onClick={onConfirm} disabled={disabled}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
});

export { DeleteConfirmModal };
